import * as cfe from 'ego-cfe';
import * as api from 'ego-sdk-js';
import React from 'react';
import { shallowEqual } from 'react-redux';

import { useContentControlRegisterHandle } from './ContentControlContext';
import { ExploreLabel } from './FeedEntryActions';
import YouTubeIcon from './icon/YouTubeIcon';
import { usePrexoSlideContext } from './PrexoSlideContext';
import SectionHeaderTab from './SectionHeaderTab';
import YouTubeCustomPlayer, { StartTimeControlLabel } from './YouTubeCustomPlayer';

const YouTubeEmbed = React.memo(
  (props: {
    ytVideoId: string;
    startProgress?: cfe.ApiHelpers.MediaStartProgress;
    duration?: number;
    portrait?: boolean;
    gutterClassName?: string;
    maxHeightShort?: boolean;
    parentSlideIndex?: number;
    mainEntry?: api.feed.IFeedEntryPair;
    headerRight?: React.ReactNode;
  }) => {
    const prexoSlideContext = usePrexoSlideContext();
    const contentControlRegisterHandle = useContentControlRegisterHandle();
    return (
      <div className="tw-flex tw-flex-col tw-aligns-center">
        <SectionHeaderTab
          title="YouTube"
          titlePrefix={<YouTubeIcon size="30px" />}
          right={
            <div className="tw-flex tw-items-center tw-gap-x-2 tw-mr-6">
              {props.startProgress?.kind === 'ts' ? (
                <StartTimeControlLabel offset={props.startProgress.ts} />
              ) : undefined}
              {props.headerRight}
              {props.mainEntry ? (
                <div
                  role="button"
                  onClick={e => {
                    e.stopPropagation();
                    if (!props.mainEntry) {
                      return;
                    }
                    window.open(cfe.ApiHelpers.getUrlPathnameForEntry(props.mainEntry.entry.entry_id), '_blank');
                  }}
                  onAuxClick={e => {
                    e.stopPropagation();
                    if (!props.mainEntry) {
                      return;
                    }
                    window.open(cfe.ApiHelpers.getUrlPathnameForEntry(props.mainEntry.entry.entry_id), '_blank');
                  }}
                >
                  <ExploreLabel
                    size="1.2rem"
                    aiAssist={props.mainEntry?.entry.ai_assist}
                    className="tw-text-primary tw-mb-1"
                  />
                </div>
              ) : null}
            </div>
          }
          round="right"
        />
        <YouTubeCustomPlayer
          ytVideoId={props.ytVideoId}
          recordStoryOpen={() => null}
          startProgress={props.startProgress}
          portrait={props.portrait}
          forceNoAutoPlay
          gutterClassName={props.gutterClassName}
          focusPlay={prexoSlideContext.slideIndex === props.parentSlideIndex}
          onEnd={prexoSlideContext.nextSlide}
          loopAfterOneEnd={prexoSlideContext.slideIndex !== -1}
          maxHeightShort={props.maxHeightShort}
          registerHandle={contentControlRegisterHandle}
        />
      </div>
    );
  },
  (prevProps, nextProps) =>
    prevProps.ytVideoId === nextProps.ytVideoId &&
    shallowEqual(prevProps.startProgress, nextProps.startProgress) &&
    prevProps.duration === nextProps.duration &&
    prevProps.portrait === nextProps.portrait &&
    prevProps.gutterClassName === nextProps.gutterClassName &&
    prevProps.maxHeightShort === nextProps.maxHeightShort &&
    prevProps.parentSlideIndex === nextProps.parentSlideIndex &&
    prevProps.mainEntry === nextProps.mainEntry,
);

export default YouTubeEmbed;
